/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import "@fontsource/roboto";
import { TDocumentDefinitions } from 'pdfmake/interfaces';


pdfMake.vfs = pdfFonts?.pdfMake?.vfs;
/** REINDERIZAÇÃO DE IMAGEM, PARA CONVERÇÃO **/
function getBase64Image(img: Blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

const CertificadoNCotroladoPdf = async (solicitacao: any, certificado: any) => {
    const imageBlob = await fetch('/img/logo/InsigniaAngola.png').then(res => res.blob());
    const imageBase64 = await getBase64Image(imageBlob) as string;
    const imageFundo = await fetch('/img/logo/logoArmed.png').then(res => res.blob());
    const imageFundo64 = await getBase64Image(imageFundo) as string;

    const certificadoValor = certificado?.[0].numeroCertificado;

    const [numero, ano] = certificadoValor?.split('/') ?? [];

    // const hoje = new Date();

    const dataActual = new Date().toLocaleDateString('pt-PT', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
    });

    pdfMake.fonts = {
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };

    const docDefinition: TDocumentDefinitions = {
        pageSize: 'A4',
        pageMargins: [15, 40, 15, 100],
        content: [
            {
                columns: [
                    {
                        text: '',
                        width: '45%'
                    },
                    {
                        image: imageBase64,
                        width: 50,
                        height: 50,
                        alignment: 'center',
                        margin: [0, 10, 0, 0],
                    },
                    {
                        width: '15%',
                        margin: [180, 0, 0, 0],
                        qr: `https://armed.gov.ao/verifica-documento/certificado/${certificado?.[0]?._id}`,
                        fit: 70
                    }
                ]

            },
            { text: 'REPÚBLICA DE ANGOLA', style: 'header' },
            { text: 'MINISTÉRIO DA SAÚDE', style: 'header' },
            { text: 'AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE', style: 'header', margin: [0, 0, 0, 3], },
            {
                columns: [
                    {
                        stack: [
                            { canvas: [{ type: 'rect', x: 17, y: 18, w: 530, h: 48, lineWidth: 1, lineColor: '#111' }] },
                            { text: `AUTORIZAÇÃO DE IMPORTAÇÃO DE MEDICAMENTOS`, style: 'subheader', margin: [0, -40, 0, 5] },
                            { text: `Nº ${numero}/ARMED/MINSA/${ano}`, style: 'subheader', margin: [0, 0, 0, 10] },
                        ],
                        margin: [0, 0, 0, 0]
                    }
                ],
            },
            {
                text: 'A Agência Reguladora de Medicamentos e Tecnologias de Saúde, Autoridade Reguladora do Sector Farmacêutico Angolano, ao abrigo da alínea q) do Decreto Presidencial nº 136/21, de 1 de Junho, que aprova o Estatuto Orgânico da ARMED; ======================================',
                style: "body",
                alignment: 'justify',
                margin: [19, 20, 20, 3]
            },
            {
                text: [
                    `Autoriza, ${solicitacao?.importador?.nome.toUpperCase() ?? ''}, a importar Material Laboratorial, que se destinam à comercialização. Abaixo as duas tabelas com a descrição dos produtos autorizados.`,
                ],
                style: "body",
                alignment: 'justify',
            },

            {
                table: {
                    headerRows: 1,
                    widths: ['*', 'auto',],
                    body: [
                        [
                            { text: 'Descrição das Substâncias Activas', style: 'header', alignment: "left", bold: true },
                            { text: 'Nome comercial', style: 'header', bold: true },
                        ],
                        ...solicitacao?.certificado.map((produto: any) => [
                            // { text: `${produto?.productoRefente?.principioActivo} ${produto?.productoRefente?.formaFarmaceutica ? `, (${produto.productoRefente.formaFarmaceutica})` : ""}` || "—", alignment: "left" },
                            { text: produto?.productoRefente?.descicaoSubstanciasActivas || "—", alignment: "left" },
                            { text: produto?.productoRefente?.nome || "—", alignment: "center" },
                        ]),
                    ],
                },
                margin: [17, 15, 8, 0],
                fontSize: 12,
                style: 'body',
            },

            {
                text: [
                    { text: 'OBS.: ', bold: true, fontSize: 12.5, color: 'black' },
                    `A presente Autorização é de uso único e só é válido o original.`,
                ], style: 'declaration',
            },

            {
                text: `AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE, EM LUANDA, AOS ${dataActual.toUpperCase()}`,
                bold: true,
                fontSize: 12.5,
                alignment: 'center',
                margin: [20, 10, 20, 5],
            },

            { text: 'O DIRECTOR GERAL', style: 'header', margin: [0, 13, 0, 0] },
        ],


        footer: (currentPage, pageCount) => {
            const footerContent: any[] =  [
                {
                    columns: [
                        {
                            stack: [
                                { text: '|', style: '', margin: [0, 10, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                                { text: '|', style: '', margin: [0, -6, 0, 0], bold: false },
                            ],
                            width: '2%',
                            fontSize: 9,
                            alignment: 'left'
                        },
                        {
                            stack: [
                                { text: 'Rua Cmdt. Che Guevara nº 86/86º,', style: '', margin: [-3, 10, 0, 0], bold: false },
                                { text: 'Bº Maculusso, Ingombota', style: '', margin: [-3, 0, 0, 0], bold: false },
                                { text: 'Tel.: +244 945 817 227', style: '', margin: [-3, 0, 0, 0], bold: false },
                                { text: 'Email: expediente@armed.minsa.gov.ao', style: '', margin: [-3, 0, 0, 0], bold: false },
                                { text: 'LUANDA-ANGOLA', style: '', margin: [-3, 0, 0, 0], bold: false },
                            ],
                            width: '68%',
                            fontSize: 9,
                            alignment: 'left'
                        },
                        {
                            width: '30%',
                            stack: [
                                {
                                    image: imageFundo64,
                                    width: 140,
                                    height: 40,
                                    alignment: 'center',
                                },
                            ],
                            margin: [0, 15, 0, 0],
                        },
                    ],
                    alignment: 'center',
                    fontSize: 8,
                    margin: [50, 0, 50, 0],
                }
            ];

            if (pageCount > 1) {
                footerContent.push({
                    text: `Página ${currentPage} de ${pageCount}`,
                    alignment: 'right',
                    fontSize: 9,
                    margin: [0, 5, 50, 3],
                    color: '#555'
                });
            }

            return footerContent;
        },

        styles: {
            header: { bold: true, alignment: 'center', margin: [0, 0, 0, 5] },
            subheader: { bold: true, alignment: 'center', margin: [0, 10, 0, 5] },
            declaration: { fontSize: 12.5, bold: true, alignment: 'center', margin: [13, 30, 17, 5], lineHeight: 1.3, color: 'red' },
            body: { fontSize: 12, alignment: 'justify', margin: [19, 3, 20, 3], lineHeight: 1.3 },
            signature: {
                fontSize: 12,
                bold: false,
                margin: [0, 10, 0, 0],
            },
        },
        defaultStyle: {
            font: 'Roboto',
        }
    };


    pdfMake.createPdf(docDefinition).open();

};
export {
    CertificadoNCotroladoPdf,
}